<template>
  <div></div>
</template>
<script>
import store from '@/store/index';
import aws_config from "../aws-config";

export default {
  data: () => ({}),
  created() {
    var domain = aws_config().DOMAIN;
    var clientId = aws_config().CLIENT_ID;
    var type = "code";
    var scope = "openid email profile";

    var callback =
      window.location.protocol + "//" + window.location.host + "/tokenize";
  
    // Save the 'verification' value, so it can be verified later to prevent CSRF attacks
    var verification = this.generateVerification();
    store.commit("setVerification", verification);
  
    window.location.href =
      "https://" +
      domain +
      "/oauth2/authorize?response_type=" +
      type +
      "&client_id=" +
      clientId +
      "&redirect_uri=" +
      callback +
      "&state=" +
      verification +
      "&scope=" +
      scope;
    
  },
  methods: {
    // generateVerification creates a random string for including in the OAuth2
    // request, which is then validated in the response.
    generateVerification() {
      var verification = "";
      var possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 32; i++) {
        verification += possible.charAt(
          Math.floor(Math.random() * possible.length)
        );
      }
      return verification;
    }
  }
};
</script>